var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.02 18L16.02 12L10.02 6L8.60999 7.41L13.19 12L8.60999 16.59L10.02 18Z","fill":"black"}})])}
var staticRenderFns = []

export { render, staticRenderFns }